<ng2-smart-table
  [settings]="settings"
  [source]="source"
  (editConfirm)="onFieldTypeChange($event)"
  (createConfirm)="onCreateField($event)"
  (deleteConfirm)="onDeleteField($event)"
></ng2-smart-table>